/**
 * Copyright (c) 2019 7thCode.(http://seventh-code.com/)
 * This software is released under the MIT License.
 * opensource.org/licenses/mit-license.php
 */

"use strict";

import {Callback, IErrorObject} from "../../../../types/platform/universe";

import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

import {GridViewComponent} from "../../platform/base/components/gridview.component";
import {PaymentCustomerUpdateDialogComponent} from "./payment-customer-update-dialog/payment-customer-update-dialog.component";
import {PaymentCardCreateDialogComponent} from "./payment-card-create-dialog/payment-card-create-dialog.component";
import {PaymentWithdrawalDialogComponent} from "./payment-withdrawal-dialog/payment-withdrawal-dialog.component";

import {SessionService} from "../../platform/base/services/session.service";
import {PaymentService} from "./payment.service";

import * as _ from 'lodash';
import {Overlay} from "@angular/cdk/overlay";
import {YesNoDialogComponent} from "../../platform/base/components/yes-no-dialog/yes-no-dialog.component";
import {ICustomerContent} from "../../../../types/plugins/universe";
import {MessageDialogComponent} from "../base/components/message-dialog/message-dialog.component";
import {Errors} from "../base/library/errors";
import {ActivatedRoute, Router} from "@angular/router";
import {CompleteDialogComponent} from "./complete-dialog/complete-dialog.component";
import {TranslateService} from "@ngx-translate/core";

import {GuestsService} from "../guests/guests.service";
import {Guests2Service} from "../guests2/guests2.service";

/**
 * Stripe
 *
 * @since 0.01
 */
@Component({
	selector: "aigia-payment",
	templateUrl: "./payment.component.html",
	styleUrls: ["./payment.component.css"],
})

export class PaymentComponent extends GridViewComponent implements OnInit {

	public isSubscribe: boolean;
	public hasPaymentMethod: boolean;
	public isCustomer: boolean;

	public pay_accounts: any[] = [];

	public params: any = {};

	/**
	 * @param session
	 * @param overlay
	 * @param matDialog
	 * @param stripeService
	 * @param accountService
	 * @param changeDetectorRef
	 * @param router
	 * @param route
	 * @param translate
	 */
	constructor(
		protected session: SessionService,
		protected overlay: Overlay,
		protected matDialog: MatDialog,
		private stripeService: PaymentService,
		private accountService: GuestsService,
		//private accountService: Guests2Service,			// todo:guests2
		public changeDetectorRef: ChangeDetectorRef,
		private router: Router,
		protected route: ActivatedRoute,
		public translate: TranslateService
	) {
		super(session, matDialog);
	}

	/**
	 * リストビューデコレータ
	 * @param object
	 */
	public toListView(object: any): any {
		object.cols = 1;
		object.rows = 1;
		return object;
	}

	/**
	 * ビューデコレータ
	 *
	 * @param data デコレーション対象
	 */
	public toView(data: any): any {
		return data;
	}

	/**
	 * トランスフォーマー
	 * @param data トランスフォーム対象
	 */
	public confirmToModel(data: any): any {
		return data;
	}

	/**
	 * @returns none
	 */
	private messageDialog(title: string, message: string, code: string, callback: (result: any) => void = (result: any) => {
	}): void {
		const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
			width: "30%",
			minWidth: "320px",
			height: "fit-content",
			data: {content: {title: "", message: message}},
			disableClose: true,
		});

		dialog.afterClosed().subscribe((result: any): void => {
			callback(result);
		});
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	private errorDialog(error: IErrorObject, callback: (result: any) => void = (error: IErrorObject) => {}): void {
		if (error) {
			if (error.code === 1) {
				this.router.navigate(['/']);
			} else {
				const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {content: {title: "Error.", message: error.message, tag: error.tag}},
					disableClose: true,
				});

				dialog.afterClosed().subscribe((result: any): void => {
					callback(result);
				});
			}
		}
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.sort = {};
		super.ngOnInit();
		this.results = [];
		this.getSession((error: IErrorObject, session: object): void => {
			if (!error) {
				this.route.queryParams.subscribe(params => {
					this.params = params;

					this.stripeService.isCustomer((error: IErrorObject, is_customer: boolean) => {
						if (!error) {
							this.isCustomer = is_customer;
							this.draw((error: IErrorObject, cards: object[] | null): void => {
							});
						} else {
							//		this.errorDialog(error);
						}
					});

				});
			}
		});
	}

	/**
	 * 再描画
	 * @param callback
	 */
	public draw(callback: Callback<object[]>): void {
		const attach_card_design = (card: any): any => {
			card.view_title = "title";
			card.view_class = "box-body";
			let padding = "****-****-****-";
			switch (card.brand) {
				case "Visa":
					card.view_title = "white-title";
					card.view_class = "white-box-body";
					break;
				case "MasterCard":
					card.view_title = "brown-title";
					card.view_class = "brown-box-body";
					break;
				case "JCB":
					card.view_title = "gold-title";
					card.view_class = "gold-box-body";
					break;
				case "American Express":
					card.view_title = "green-title";
					card.view_class = "green-box-body";
					padding = "****-******-*";
					break;
				case "Diners Club":
					card.view_title = "blue-gray-title";
					card.view_class = "blue-gray-box-body";
					padding = "****-******-";
					break;
				default:
			}
			if (card.is_default) {
				card.view_class = "default-" + card.view_class;
			}

			card.display_no = padding + card.last4;
			return card;
		}

		this.Progress(true);
		this.accountService.belongs("", (error: IErrorObject, accounts: any[]) => {
			this.pay_accounts = accounts.filter((account) => {
				return (account.content.accounting);
			});
		});

		this.stripeService.is_subscribe((error: IErrorObject, result: boolean) => {
			if (!error) {
				this.isSubscribe = result;
				this.stripeService.retrieveCustomer((error: IErrorObject, result: any) => {
					if (!error) {
						if (result) {
							this.hasPaymentMethod = (result.sources.data.length > 0);
							const cards = result.sources.data;
							const default_source = result.sources.default;

							const results = cards.map((card: any) => {
								card = this.toListView(card);
								card.is_default = (card.id === default_source);
								return attach_card_design(card);
							});

							this.results = _.sortBy(results, [(o) => {
								return o.id;
							}]);

						} else {
							this.results = [];
						}
						callback(null, this.results);
					} else {
						callback(error, null);
					}
				});
			} else {
				switch (error.code) {
					case 1:
						break;
					case 11:
						break;
					default:
						this.errorDialog(error);
				}
				callback(error, null);
			}
			this.Progress(false);
		});
	}

	/**
	 * todo
	 */
	public createCustomer(): void {
		this.Progress(true);
		this.stripeService.createCustomer({email: "test@test.com"}, (error: IErrorObject, result: any) => {
			if (!error) {
				this.draw((error: IErrorObject, cards: object[] | null): void => {
					if (error) {
						this.errorDialog(error);
					}
				});
			} else {
				this.errorDialog(error);
			}
			this.Progress(false);
		})
	}

	/**
	 * todo
	 */
	public retrieveCustomer(): void {
		this.Progress(true);
		this.stripeService.retrieveCustomer((error: IErrorObject, result: any) => {
			if (!error) {
				this.draw((error: IErrorObject, cards: object[] | null): void => {
					if (error) {
						this.errorDialog(error);
					}
				});
			} else {
				this.errorDialog(error);
			}
			this.Progress(false);
		})
	}

	/**
	 * todo
	 */
	public deleteCustomer(callback: Callback<any>): void {
		this.Progress(true);
		this.stripeService.deleteCustomer((error: IErrorObject, result: any) => {
			if (!error) {
				this.draw((error: IErrorObject, cards: object[] | null): void => {
					if (!error) {
						callback(error, cards);
					} else {
						callback(error, null);
					}
				});
			} else {
				callback(error, null);
			}
			this.Progress(false);
		})
	}

	/**
	 * todo
	 */
	public createSource(card: any, callback: Callback<any>): void {
		this.stripeService.createSource({card: card}, (error: IErrorObject, result: any) => {
			if (!error) {
				this.draw((error: IErrorObject, cards: object[] | null): void => {
					if (!error) {
						callback(error, cards);
					} else {
						callback(error, null);
					}
				});
			} else {
				callback(error, null);
			}
		})
	}

	/**
	 * todo
	 */
	public retrieveSource(index: number): void {
		this.stripeService.retrieveSource(index, (error: IErrorObject, result: any) => {
			if (!error) {
				this.draw((error: IErrorObject, cards: object[] | null): void => {
					if (error) {
						this.errorDialog(error);
					}
				});
			} else {
				this.errorDialog(error);
			}
		})
	}

	/**
	 * todo
	 */
	public updateSource(index: number, content: any): void {
		this.stripeService.updateSource(index, content, (error: IErrorObject, result: any) => {
			if (!error) {
				this.draw((error: IErrorObject, cards: object[] | null): void => {
					if (error) {
						this.errorDialog(error);
					}
				});
			} else {
				this.errorDialog(error);
			}
		})
	}

	/**
	 * todo
	 */
	public updateDefault(id: any) {
		this.stripeService.updateCustomer({content: {default_source: id.value}}, (error: IErrorObject, result: any) => {
			if (!error) {
				this.draw((error: IErrorObject, cards: object[] | null): void => {
					if (!error) {
						this.changeDetectorRef.detectChanges();
					} else {
						this.errorDialog(error);
					}
				});
			} else {
				this.errorDialog(error);
			}
		})
	}

	/**
	 * todo
	 */
	public updateSubscription() {
		const metadata = {order_id: ''};
		this.Progress(true);
		this.stripeService.update_subscribe(metadata, (error: IErrorObject, result: any) => {
			if (!error) {
				this.draw((error: IErrorObject, cards: object[] | null): void => {
					if (!error) {
						this.changeDetectorRef.detectChanges();
					} else {
						this.errorDialog(error, () => {
						});
					}
				});
			} else {
				this.errorDialog(error, () => {
				});
			}
			this.Progress(false);
		})
	}

	/**
	 * todo
	 */
	public cancelSubscription() {
		this.Progress(true);
		this.stripeService.cancel_subscribe((error: IErrorObject, result: any) => {
			if (!error) {
				this.draw((error: IErrorObject, cards: object[] | null): void => {
					if (!error) {
						this.changeDetectorRef.detectChanges();
					} else {
						this.errorDialog(error, () => {
						});
					}
				});
			} else {
				this.errorDialog(error, () => {
				});
			}
			this.Progress(false);
		})
	}

	/**
	 * todo
	 */
	public defaultCard(is_default: any) {
		let style = {'font-weight': '300', 'background-color': '#bdc7c3', 'color': '#505050'};
		if (is_default) {
			style = {'font-weight': '800', 'background-color': '#eefcf7', 'color': '#1e1e1e'};
		}
		return style;
	}

	/**
	 * todo
	 */
	public onDeleteSource(card_id: string): void {
		const resultDialogContent: any = {title: this.translate.instant('クレジットカード情報の削除'), message: this.translate.instant('クレジットカード情報情報を削除しても、退会したことにはなりません。しばらくお使いにならない場合は退会を行ってから削除を行ってください。先に削除してしまった場合はもう一度クレジットカード情報を設定いただくと退会が可能です。')};
		const dialog: MatDialogRef<any> = this.matDialog.open(YesNoDialogComponent, {
			width: "30%",
			minWidth: "320px",
			height: "fit-content",
			panelClass: "dark-card",
			data: {
				session: this.currentSession,
				content: resultDialogContent,
			},
			disableClose: true,
		});
		dialog.afterClosed().subscribe((result: object): any => {
			if (result) { // if not cancel then
				this.stripeService.deleteSource(card_id, (error: IErrorObject, result: any) => {
					if (!error) {
						this.draw((error: IErrorObject, cards: object[] | null): void => {
							if (!error) {
								this.Complete("", result);
							} else {
								this.errorDialog(error, () => {
									this.Complete("error", error);
								});
							}
						});
					} else {
						this.errorDialog(error, () => {
							this.Complete("error", error);
						});
					}
				})
			}
		});
	}

	/**
	 * クリエイトダイアログ
	 */
	public createCardDialog(): void {

		const initalData = {
			number: "",
			exp_month: "",
			exp_year: "",
			cvc: ""
		};

		const dialog: MatDialogRef<any> = this.matDialog.open(PaymentCardCreateDialogComponent, {
			minWidth: "320px",
			maxWidth: "620px",
			height: "fit-content",
			panelClass: "dark-card",
			data: {content: initalData},
			disableClose: true,
		});

		dialog.beforeClosed().subscribe((result: any): void => {
			if (result) { // if not cancel then
				this.Progress(true);
				this.createSource(result.content, (error, cards) => {
					if (!error) {

					} else {
						switch (error.code) {
							case 100:
								this.errorDialog(Errors.generalError(100, "住所登録が必要です。", "A00311"));
								break;
							default:
								this.errorDialog(error);
								break;
						}
					}
					this.Progress(false);
				});
			}
		});

		dialog.afterClosed().subscribe((result: any): void => {
			if (result) {
				this.Complete("", result);
			}
		});

	}

	/**
	 * アップデートダイアログ
	 */
	public createCustomerDialog(): void {

		const create: ICustomerContent = {
			address: {  // The customer’s address.
				city: "", // City, district, suburb, town, or village.
				country: "", // Two-letter country code (ISO 3166-1 alpha-2).
				line1: "", // Address line 1 (e.g., street, PO Box, or company name).
				line2: "", // Address line 2 (e.g., apartment, suite, unit, or building).
				postal_code: "", // ZIP or postal code.
				state: "" // State, county, province, or region.
			},
			description: "", // An arbitrary string attached to the object. Often useful for displaying to users.
			email: this.currentSession.username, // The customer’s email address.
			metadata: {order_id: ''}, // Set of key-value pairs that you can attach to an object. This can be useful for storing additional information about the object in a structured format.
			name: "",  // The customer’s full name or business name.
			phone: "", // The customer’s phone number.
			shipping: { // Mailing and shipping address for the customer. Appears on invoices emailed to this customer.
				address: {
					city: "", // City, district, suburb, town, or village.
					country: "", // Two-letter country code (ISO 3166-1 alpha-2).
					line1: "", // Address line 1 (e.g., street, PO Box, or company name).
					line2: "", // Address line 2 (e.g., apartment, suite, unit, or building).
					postal_code: "", // ZIP or postal code.
					state: "" // State, county, province, or region.
				},
				name: "", // Customer name.
				phone: "", // Customer phone (including extension).
			}
		}

		const dialog: MatDialogRef<any> = this.matDialog.open(PaymentCustomerUpdateDialogComponent, {
			minWidth: "320px",
			maxWidth: "620px",
			height: "fit-content",
			panelClass: "dark-card",
			data: {content: create},
			disableClose: true,
		});

		dialog.beforeClosed().subscribe((result: any): void => {
			if (result) { // if not cancel then
				this.Progress(true);
				this.stripeService.createCustomer(result.content, (error: IErrorObject, result: any) => {
					this.stripeService.isCustomer((error: IErrorObject, is_customer: boolean) => {
						if (!error) {
							this.isCustomer = is_customer;
							this.draw((error: IErrorObject, cards: object[] | null): void => {
							});
						} else {
							this.errorDialog(error);
						}
					});
					this.Progress(false);
				})
			}
		});

		dialog.afterClosed().subscribe((result: any): void => {
			if (result) {
				this.Complete("", result);
			}
		});

	}

	/**
	 * アップデートダイアログ
	 */
	public updateCustomerDialog(): void {
		this.stripeService.retrieveCustomer((error: IErrorObject, result: any) => {
			if (!error) {
				if (result) {
					const dialog: MatDialogRef<any> = this.matDialog.open(PaymentCustomerUpdateDialogComponent, {
						minWidth: "320px",
						height: "fit-content",
						panelClass: "dark-card",
						data: {content: result.sources.updateable},
						disableClose: true,
					});

					dialog.beforeClosed().subscribe((result: any): void => {
						if (result) { // if not cancel then
							this.Progress(true);
							this.stripeService.updateCustomer(result, (error: IErrorObject, result: any) => {
								if (!error) {
									this.draw((error: IErrorObject, cards: object[] | null): void => {
										if (!error) {
											this.changeDetectorRef.detectChanges();
											const complete: MatDialogRef<any> = this.matDialog.open(CompleteDialogComponent, {
												width: "50%",
												minWidth: "320px",
												height: "fit-content",
												panelClass: "dark-card",
												data: {content: {title: "", message: this.translate.instant('更新しました。')}},
												disableClose: true,
											});

											complete.beforeClosed().subscribe((result: any): void => {
												this.changeDetectorRef.detectChanges();
												location.reload();
											});

											complete.afterClosed().subscribe((result: any): void => {
												this.Complete("", result);
											});

										} else {
											this.errorDialog(error);
										}
									});
								} else {
									this.errorDialog(error);
								}
								this.Progress(false);
							})
						}
					});

					dialog.afterClosed().subscribe((result: any): void => {
						if (result) {
							this.Complete("", result);
						}
					});
				} else {

				}
			} else {
				this.errorDialog(error);
				this.Complete("error", error);
			}
		})
	}

	/**
	 * 削除
	 */
	public onDeleteCustomer(): void {
		const resultDialogContent: any = {title: "お支払いカード情報の削除", message: "お支払いカード情報を削除します。"};
		const dialog: MatDialogRef<any> = this.matDialog.open(YesNoDialogComponent, {
			width: "30%",
			minWidth: "320px",
			height: "fit-content",
			panelClass: "dark-card",
			data: {
				session: this.currentSession,
				content: resultDialogContent,
			},
			disableClose: true,
		});
		dialog.afterClosed().subscribe((result: any): void => {
			if (result) { // if not cancel then
				this.stripeService.deleteCustomer((error: IErrorObject, result: any) => {
					if (!error) {
						this.stripeService.isCustomer((error: IErrorObject, is_customer: boolean) => {
							if (!error) {
								this.isCustomer = is_customer;
								this.draw((error: IErrorObject, cards: object[] | null): void => {
								});
							} else {
								this.errorDialog(error);
							}
						});
					} else {
						this.errorDialog(error);
					}
				})
			}
		});
	}

	/**
	 * todo
	 */
	public subscribe(): void {

		const charge = {
			amount: 1,
			currency: "jpy",
			description: "",
			capture: true
		}

		this.Progress(true);
		this.stripeService.subscribe(charge, (error: IErrorObject, result: any) => {
			if (!error) {
				this.draw((error: IErrorObject, cards: object[] | null): void => {
					if (!error) {

						const dialog: MatDialogRef<any> = this.matDialog.open(CompleteDialogComponent, {
							width: "50%",
							minWidth: "320px",
							height: "fit-content",
							panelClass: "dark-card",
							data: {content: {title: "", message: this.translate.instant('入会完了しました')}},
							disableClose: true,
						});

						dialog.beforeClosed().subscribe((result: any): void => {
							this.changeDetectorRef.detectChanges();
							location.reload();
						});

						dialog.afterClosed().subscribe((result: any): void => {
							if (result) {
								this.Complete("", result);
							}
						});

					} else {
						this.errorDialog(error);
					}
				});
			} else {
				this.errorDialog(error);
			}
			this.Progress(false);
		})
	}

	/**
	 * todo
	 */
	public unSubscribe(): void {
		this.stripeService.retrieveCustomer((error: IErrorObject, result: any) => {
			if (!error) {
				result.sources.updateable.description = "";
				const dialog: MatDialogRef<any> = this.matDialog.open(PaymentWithdrawalDialogComponent, {
					width: "50%",
					minWidth: "320px",
					height: "fit-content",
					panelClass: "dark-card",
					data: {content: result.sources.updateable},
					disableClose: true,
				});

				dialog.beforeClosed().subscribe((result: any): void => {
					if (result) { // if not cancel then
						this.Progress(true);
						this.stripeService.cancel_subscribe((error: IErrorObject, result: any) => {
							if (!error) {
								this.draw((error: IErrorObject, cards: object[] | null): void => {
									if (!error) {
										this.changeDetectorRef.detectChanges();

										// dialog
										const complete: MatDialogRef<any> = this.matDialog.open(CompleteDialogComponent, {
											width: "50%",
											minWidth: "320px",
											height: "fit-content",
											panelClass: "dark-card",
											// data: {content: result.sources.updateable},
											data: {content: {title: "", message: this.translate.instant('退会完了しました')}},

											disableClose: true,
										});

										complete.beforeClosed().subscribe((result: any): void => {
											this.changeDetectorRef.detectChanges();
											location.reload();
										});

										complete.afterClosed().subscribe((result: any): void => {
											this.Complete("", result);
										});

									} else {
										this.errorDialog(error);
									}
								});
							} else {
								this.errorDialog(error, () => {
								});
							}
							this.Progress(false);
						})
					}
				});

				dialog.afterClosed().subscribe((result: any): void => {
					if (result) {
						this.Complete("", result);
					}
				});
			} else {
				this.errorDialog(error, () => {
				});
				this.Complete("error", error);
			}
		})
	}

}
